import "./Root.scss";
import React, { useState, useRef, useEffect, useContext } from "react";
import HTMLPreview from "../HtmlPreview/HTMLPreview";
import GrapejsEditor from "../GrapejsEditor/GrapejsEditor";
import StepperComp from "../Stepper/Stepper";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
// import CircularProgress from "@mui/material/CircularProgress";
// import CircularProgress from "@material-ui/core/CircularProgress";
import CustomCircularProgress from "./../CustomCircularProgress";

import FileUpload from "../FileUpload/FileUpload";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonHeader from "../FileUpload/ButtonHeader";
import {
  imageIntermediateSave,
  intermediateSave,
  processHTML,
  uploadFile,
} from "../../services/api";
import AddMetadata from "../AddMetadata/AddMetadata";
import FileContext from "../../context/FileContext";
import { ToastContainer, toast } from "react-toastify";
import ImageLayout from "../ImageLayout/ImageLayout";
import {
  STEPPER_STEP_MODIFY_HTML,
  STEPPER_STEP_MODIFY_IMAGE,
  STEPPER_STEP_ADD_METADATA,
  STEPPER_STEP_UPLOADFILE,
  UPLOAD_IMAGE_PROGRESS_MESSAGE,
  UPLOAD_PDF_PROGRESS_MESSAGE,
} from "./constants";
import { DUMMY_IMAGE_FILE } from "../ImageLayout/dummy-response";

const steps = ["Upload File", "Modify Image", "Modify HTML", "Add Metadata"];

function Root() {
  const [arrayOfBoxesDrawn, setArrayOfBoxesDrawn] = useState([]);
  const [numberOfLayouts, setNumberOfLayouts] = useState(0);
  const arrayOfBoxesDrawnRef = useRef(arrayOfBoxesDrawn);
  const [activeStep, setActiveStep] = React.useState("0");
  const [prevStep, setPrevStep] = React.useState(0);
  const [file, setFile] = useState();
  const [uploadedFfileDetails, setUploadedFileDetails] = useState();
  const [imageFileDetails, setImageFileDetails] = useState();
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isGJSLoading, setIsGJSLoading] = useState(true);

  // const [isExportTriggered, setIsExportTriggered] = useState(false);
  const [exportCount, setExportCount] = useState(0);
  const [publishHTML, setPublishHTML] = useState(0);
  const [publishHTMLDSP, setPublishHTMLDSP] = useState(0);

  const [publishResponsiveHTML, setPublishResponsiveHTML] = useState(0);
  const [userGeneratedHTML, setUserGeneratedHTML] = useState("");
  const [isLayoutGenerated, setIsLayoutGenerated] = useState(false);
  const [isImageLayoutGenerated, setIsImageLayoutGenerated] = useState(false);
  const [arrayOfBoxesDrawnImage, setarrayOfBoxesDrawnImage] = useState([]);

  const [generateLayout, setGenerateLayout] = useState(false);
  const genLayoutRef = useRef(generateLayout);
  const [genLayoutClicked, setGenLayoutClicked] = useState(false);
  const fileContext = useContext(FileContext);
  const [html, setHtml] = useState(null);
  const [fileUploadMessage, setFileUploadMessage] = useState(null);
  const htmlRef = useRef(html);
  const [data, setData] = useState("");
  const dataRef = useRef(data);
  const [rhsHtmlForExport, setRhsHtmlForExport] = useState("");
  const rhsHtmlForExportRef = useRef(rhsHtmlForExport);
  const [cooridinatesFromAPI, setCooridinatesFromAPI] = useState([]);
  const innerLayoutsRef = useRef(cooridinatesFromAPI);
  const [usrGenHtML, setUsrGenHtML] = useState();
  const usrGenHtMLRef = useRef(usrGenHtML);
  const [imageDimensions, setImageDimensions] = useState({
    originalWidth: "",
    originalHeight: "",
    modifiedWidth: "",
    modifiedHeight: "",
  });
  const [scaleFactorImage, setScaleFactorImage] = useState({
    toScaleDown: 1,
  });
  const [croppingBoxes, setCroppingBoxes] = useState([1]);
  const [modifiedCroppedImage, setModifiedCroppedImage] = useState({});
  const [downloadHTML, setDownloadHTML] = useState(false);
  const [responsiveHtml, setResponsiveHtml] = useState(false);
  const [isDownloadZip, setIsDownloadZip] = useState(false);
  const [isDownloadZipDSP, setIsDownloadZipDSP] = useState(false);

  const [clearAllLayoutClicked, setClearAllLayoutClicked] = useState(false);
  const [disableGenerateLayout, setDisableGenerateLayout] = useState(true);
  const [isBackDisabled, setIsBackDisabled] = useState(false);
  const [upscaledHTMLUsrGnrtdPath, setUpscaledHTMLUsrGnrtdPath] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [defaultHtmlStyles, setDefaultHtmlStyles] = useState("");
  const [holdCurrentFileDetails, setHoldCurrentFileDetails] = useState({});
  const [positionAbsolute, setPositionAbsolute] = useState(false);
  const [isPublishClicked, setIsPublishClicked] = useState(1);


  const navigate = useNavigate();
  useEffect(() => {
    const storedStep = JSON.parse(window.localStorage.getItem("activeStep"));
    if (storedStep) {
      setActiveStep(storedStep);
    } else {
      setActiveStep(0);
    }
  }, []);

  useEffect(() => {
    if (fileContext.isLogoutClicked) {
      navigate("/dynamic-layout");
    }
  }, [fileContext.isLogoutClicked]);

  useEffect(() => {
    arrayOfBoxesDrawnRef.current = arrayOfBoxesDrawn;
    setNumberOfLayouts(arrayOfBoxesDrawn.length);
  }, [arrayOfBoxesDrawn]);

  useEffect(() => {
    //navigateIssue
    if (fileContext.file) {
      if (
        fileContext?.file?.file_conversion_pages?.[0]?.message?.step ===
        STEPPER_STEP_MODIFY_IMAGE
      ) {
        if (holdCurrentFileDetails?.id) {
          setImageFileDetails(holdCurrentFileDetails);
        } else {
          setImageFileDetails(fileContext.file);
        }
        // setImageFileDetails(DUMMY_IMAGE_FILE);
      } else if (
        fileContext?.file?.file_conversion_pages[0]?.message?.step ===
        STEPPER_STEP_MODIFY_HTML ||
        fileContext?.file?.file_conversion_pages[0]?.message?.step ===
        STEPPER_STEP_ADD_METADATA //Filedetails were not set for ADD_METADATA page
      ) {
        setUploadedFileDetails(fileContext.file);
      }
      setActiveStep(fileContext?.file?.file_conversion_pages[0].message?.step);
    }

    if (fileContext.imageFile) {
      //setcroppingboxes here
      setImageFileDetails(fileContext.imageFile);
    }
  }, [fileContext.file, fileContext.imageFile]);

  useEffect(() => {
    setGenerateLayout(genLayoutRef.current);
    setNumberOfLayouts(-11);
  }, [genLayoutRef.current]);

  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  useEffect(() => {
    window.localStorage.setItem("activeStep", activeStep);

    if (fileContext.file) {
      if (activeStep === STEPPER_STEP_MODIFY_IMAGE) {
        if (holdCurrentFileDetails?.id) {
          setImageFileDetails(holdCurrentFileDetails);
        } else {
          setImageFileDetails(fileContext.file);
          // setImageFileDetails(DUMMY_IMAGE_FILE);
        }
      } else if (activeStep === STEPPER_STEP_MODIFY_HTML) {
        setUploadedFileDetails(fileContext.file);
      }
    }
  }, [activeStep]);

  const HtMLStringToDOMElementFromExport = (htmlString) => {
    // Create a DOMParser

    const parser = new DOMParser();

    // Parse the HTML string into a DOM element
    const doc = parser.parseFromString(htmlString, "text/html");
    // Extract the html element from the parsed document

    return doc.querySelector("html");
  };
  const cssStringToCSSStyles = (cssString) => {
    const cssBlocks = cssString

      .split("}")
      .filter((block) => block.trim() !== "");

    // Initialize an empty object to store the CSS styles
    const cssStyles = {};

    // Iterate through the CSS blocks and parse them into key-value pairs
    cssBlocks.forEach((block) => {
      // Split the block into selector and properties
      const [selector, properties] = block
        .split("{")
        .map((item) => item.trim());

      // Initialize an empty object for the selector
      const selectorStyles = {};

      // Split the properties into individual style declarations
      const styleDeclarations = properties
        .split(";")
        .filter((declaration) => declaration.trim() !== "");

      // Iterate through style declarations and parse them into key-value pairs
      styleDeclarations.forEach((declaration) => {
        // const [property, value] = declaration.split(":");

        const [property, value] = declaration
          .split(/:(.+)/)
          .map((item) => item.trim());

        // .map((item) => item.trim());
        selectorStyles[property] = value;
      });

      // Store the selector styles in the main CSS styles object
      cssStyles[selector] = selectorStyles;
    });
    return cssStyles;
  };
  const replaceIdsWithStyles = (divElement, cssStyles) => {
    // const deepaDiv = document.getElementById("deepa");
    // const currentPadding = deepaDiv.style.padding;
    // deepaDiv.removeAttribute("id");
    // deepaDiv.setAttribute("style", `padding:${currentPadding}`);

    for (let prop in cssStyles) {
      if (prop.startsWith("#")) {
        let currentDiv = divElement.querySelector(prop);
        const styleObj = cssStyles[prop];
        if (fileContext.file.application_type === 2 || prop !== "#wrapper")
          currentDiv.removeAttribute("id");
        let newStr = "";
        for (let prop in styleObj) {
          newStr = newStr + prop + ":" + styleObj[prop] + ";";
        }
        currentDiv.setAttribute("style", newStr);
      }
    }
  };

  function ObjectOfObjectsToArrayOfObjects() {
    // imageFileDetails.cropped_image_data;
    //croppingBoxes;
    let inputString =
      imageFileDetails.file_conversion_pages[0].cropped_image_data
        .cropped_image_1.imageURL;
    let desiredString = "";
    if (inputString) {
      let lastSlashIndex =
        imageFileDetails.file_conversion_pages[0].cropped_image_data.cropped_image_1?.imageURL.lastIndexOf(
          "/"
        );
      desiredString = inputString.substring(0, lastSlashIndex + 1);
    }
    // croppingBoxes.forEach((box, index) => {
    //   let bottom = box?.bottom;
    //   let top = box?.top;

    //   let rhsObj = {
    //     height_end: parseFloat(bottom) / scaleFactorImage.toScaleDown,
    //     height_start: parseFloat(top) / scaleFactorImage.toScaleDown,
    //     width: imageDimensions.originalWidth,
    //     imageURL: desiredString + "cropped_image_" + (index + 1) + ".jpg",
    //   };
    // });

    let newObject = {};

    croppingBoxes.forEach((box, index) => {
      let key = `cropped_image_${index + 1}`;
      newObject[key] = {
        height_end: parseFloat(box.bottom) / scaleFactorImage.toScaleDown,
        height_start: parseFloat(box.top) / scaleFactorImage.toScaleDown,
        width: imageDimensions.originalWidth,
        imageURL: desiredString
          ? desiredString + "cropped_image_" + (index + 1) + ".jpg"
          : undefined,
      };
    });
    return newObject;
  }
  const customDrag = (e, j) => {
    let data = JSON.stringify(e.target);
    e.dataTransfer.setData("text", `${e.target.outerHTML}`);

    setData(e.target.getAttribute("name"));
  };

  const onFileUpload = (file) => {
    setFile(file);
  };

  const handleNext = () => {
    if (activeStep === STEPPER_STEP_UPLOADFILE) {
      setIsFileUploading(true);
    }
    setIsGJSLoading(true);
    setTimeout(() => {
      setPrevStep(activeStep);
      if (activeStep === STEPPER_STEP_UPLOADFILE) {
        uploadFile(file)
          .then((res) => {
            // setFileUploadMessage("Successfully Uploaded file");
            toast.success("Successfully Uploaded file");
            setIsFileUploading(false);
            // setTimeout(() => {
            //   setFileUploadMessage(null);

            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setImageFileDetails(res.data);
            fileContext.selectImageFile(res.data);
            // let tempArray = [];
            // for (let x in res.data.cropped_image_data) {
            //   res.data.cropped_image_data[x].index = x;
            //   tempArray.push(res.data.cropped_image_data[x]);
            // }
            // setCroppingBoxes(tempArray);
          })
          .catch((err) => {
            let errorMessage = "Something went wrong! Please try again.";

            if (err?.response?.data?.message) {
              errorMessage = err?.response?.data?.message;
            }

            toast.error(errorMessage);
            setIsFileUploading(false);
            // setTimeout(() => {
            //   setFileUploadMessage(null);
            // }, 2000);
          });
      } else if (activeStep === STEPPER_STEP_MODIFY_IMAGE) {
        let newArray = [];
        let scaleFactor = 1;

        if (imageDimensions.modifiedWidth) {
          scaleFactor =
            imageDimensions.modifiedWidth / imageDimensions.originalWidth;
        }
        //   setScaleFactorImage({ ...scaleFactorImage, toScaleUp: scaleFactor });
        // }

        arrayOfBoxesDrawnImage.forEach((element) =>
          newArray.push({
            x_1: parseFloat(element.left) / scaleFactor,
            y_1: parseFloat(element.top) / scaleFactor,
            x_2: parseFloat(element.right) / scaleFactor,
            y_2: parseFloat(element.bottom) / scaleFactor,
            width: element.width,
            height: element.height,
            zIndex: element.zIndex,
            scaleFactorToScaleDown: scaleFactor,
            blocktype: element.blocktype || "LAYOUT_DEFAULT",
          })
        );
        let body = {
          bbox_json: newArray,
          image_file_path:
            imageFileDetails?.file_conversion_pages[0].image_path,
          generatedUUID: imageFileDetails?.file_conversion_pages[0].page_uuid,
          file_name:
            imageFileDetails.file_name ||
            imageFileDetails?.pdf_file_path?.split("/").pop(),
          // file_name: "MBI-34596_Poland_Jardiance_Email_Sample16 1.pdf",
          id: imageFileDetails?.file_conversion_pages[0]?.id,
          parent_id: imageFileDetails?.file_conversion_pages[0]?.conversion_id,
          cropped_image_data: Object.values(modifiedCroppedImage).length
            ? modifiedCroppedImage
            : ObjectOfObjectsToArrayOfObjects(
              imageFileDetails?.file_conversion_pages[0].cropped_image_data,
              {}
            ),
          application_type: imageFileDetails?.application_type,
          pdf_file_path: imageFileDetails?.pdf_file_path,
          page_index: imageFileDetails?.pageNumber,
        };
        setIsFileUploading(true);
        processHTML(body)
          .then((resp) => {
            window.localStorage.removeItem("gjsProject");
            fileContext.selectFile(resp.data);

            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            toast.success("HTML loaded successfully!");
            setIsFileUploading(false);
            setUploadedFileDetails(resp.data);
            setArrayOfBoxesDrawn([]);
          })
          .catch((err) => {
            // setActiveStep((prevActiveStep) => prevActiveStep + 1);
            toast.error("Failed to load HTML!");
            setIsFileUploading(false);
            setIsGJSLoading(false);
          });
        // pocessNewImageDimensions()
        //   .then((resp) => {
        //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
        //     toast.success("HTML loaded successfully!");
        //     setIsFileUploading(false);
        //     setUploadedFileDetails(resp.data[0]);
        //   })
        //   .catch((err) => {
        //     toast.error("Failed to load HTML!");
        //     setIsFileUploading(false);
        //   });
      } else if (activeStep == STEPPER_STEP_MODIFY_HTML) {
        setTimeout(() => {
          setExportCount(exportCount + 1);
        }, 100);
        // setTimeout(() => {
        //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // }, 400);
        // setIsExportTriggered(false);
      }
    }, 1000);
  };

  const exportClicked = () => {
    setPublishHTML(publishHTML + 1);
  };
  const exportDSPClicked = () => {
    setPublishHTMLDSP(publishHTMLDSP + 1);
  };

  const exportResponsiveHTML = () => {
    setPublishResponsiveHTML(publishResponsiveHTML + 1);
  };
  const downloadClicked = (flag) => {
    setDownloadHTML(flag);
  };
  const downloadResponsiveHTML = (flag) => {
    setResponsiveHtml(flag);
  };

  const downloadZip = (flag) => {
    setIsDownloadZip(flag);
  };
  const downloadZipDSP = (flag) => {
    setIsDownloadZipDSP(flag);
  };
  const getUserGeneratedHTML = (userGeneratedHTML) => {
    setUserGeneratedHTML(userGeneratedHTML);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setExportCount(0);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const modifyImageIntermediateSave = () => {
    if (!arrayOfBoxesDrawnImage?.length) return;

    const body = {
      bbox_json: arrayOfBoxesDrawnImage,
      image_file_path: imageFileDetails?.file_conversion_pages[0]?.image_path,
      generatedUUID: imageFileDetails?.file_conversion_pages[0].page_uuid,
      file_name: imageFileDetails?.pdf_file_path?.split("/").pop(),
      id: imageFileDetails?.file_conversion_pages[0].id,
      parent_id: imageFileDetails?.file_conversion_pages[0]?.conversion_id,
      cropped_image_data: Object.values(modifiedCroppedImage).length
        ? modifiedCroppedImage
        : ObjectOfObjectsToArrayOfObjects(
          imageFileDetails?.file_conversion_pages[0].cropped_image_data,
          {}
        ),
    };

    imageIntermediateSave(body)
      .then((res) => { })
      .catch((err) => { });
  };
  const HtMLStringToDOMElement = (htmlString) => {
    // Create a DOMParser

    const parser = new DOMParser();

    // Parse the HTML string into a DOM element
    const doc = parser.parseFromString(htmlString, "text/html");
    // Extract the html element from the parsed document

    return doc.querySelector("html");
  };

  // function rgbaToHex(rgba) {
  //   if (!rgba)
  //     return "";
  //   // Extract the numbers from the rgba string
  //   const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]+)?\)/);

  //   if (!match) {
  //     throw new Error("Invalid RGBA format");
  //   }

  //   // Parse RGB values and optional alpha
  //   const r = parseInt(match[1]);
  //   const g = parseInt(match[2]);
  //   const b = parseInt(match[3]);
  //   const a = match[4] !== undefined ? parseFloat(match[4]) : 1;

  //   // Convert RGB to HEX
  //   const toHex = (value) => value.toString(16).padStart(2, '0');
  //   return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  // }

  const replaceWithNewDimensions = (sectionDiv, scaleFactor, layout) => {
    let width =
      positionAbsolute || layout === "redLayout" || sectionDiv.tagName === "TABLE"
        ? "width"
        : "minWidth";
    let height = (sectionDiv.tagName === "TABLE" || positionAbsolute) ? "height" : "minHeight";
    var currentsectionHeight = parseFloat(sectionDiv.style[height]);
    var currentsectionWidth = parseFloat(sectionDiv.style[width]);
    //calculate calefactor for other divs
    // let currentWidth = 600;
    // let desiredWidth = 1024;
    // var scaleFactor = desiredWidth / currentWidth;

    var currentsectionTop = parseFloat(sectionDiv.style.top);
    var currentsectionLeft = parseFloat(sectionDiv.style.left);
    var currentsectionMarginTop = parseFloat(sectionDiv.style.marginTop);
    var currentsectionMarginLeft = parseFloat(sectionDiv.style.marginLeft);
    var currentsectionMarginRight = parseFloat(sectionDiv.style.marginRight);
    var currentsectionMarginBottom = parseFloat(sectionDiv.style.marginBottom);

    var desiredHeight = currentsectionHeight * scaleFactor;
    var desiredWidth1 = currentsectionWidth * scaleFactor;
    let desiredTop = currentsectionTop * scaleFactor;
    let desiredLeft = currentsectionLeft * scaleFactor;
    let desiredMarginTop = currentsectionMarginTop * scaleFactor;
    let desiredMarginLeft = currentsectionMarginLeft * scaleFactor;
    let desiredMarginRight = currentsectionMarginRight * scaleFactor;
    let desiredMarginBottom = currentsectionMarginBottom * scaleFactor;

    // if (positionAbsolute) {
    //   sectionDiv.style.top = desiredTop.toFixed(2) + "px";
    //   sectionDiv.style.left = desiredLeft.toFixed(2) + "px";
    //   sectionDiv.style.marginTop = desiredMarginTop.toFixed(2) + "px";
    //   sectionDiv.style.marginLeft = desiredMarginLeft.toFixed(2) + "px";
    //   sectionDiv.style.marginRight = desiredMarginRight.toFixed(2) + "px";
    //   sectionDiv.style.marginBottom = desiredMarginBottom.toFixed(2) + "px";
    // }
    // else {
    sectionDiv.style.top = desiredTop.toFixed(2) + "px";
    sectionDiv.style.left = desiredLeft.toFixed(2) + "px";
    sectionDiv.style.marginTop = desiredMarginTop.toFixed(2) + "px";
    sectionDiv.style.marginLeft = desiredMarginLeft.toFixed(2) + "px";
    sectionDiv.style.marginRight = desiredMarginRight.toFixed(2) + "px";
    sectionDiv.style.marginBottom = desiredMarginBottom.toFixed(2) + "px";
    // }
    sectionDiv.style[width] = desiredWidth1.toFixed(2) + "px";
    sectionDiv.style[height] = desiredHeight.toFixed(2) + "px";
  };
  const ReplaceHTMLContentsStyles = (sectionDiv, scaleFactor) => {
    var elementsWithPxValues = sectionDiv.querySelectorAll('*[style*="px"]');
    for (var i = 0; i < elementsWithPxValues.length; i++) {
      var element = elementsWithPxValues[i];
      var newRelativeValueFont =
        parseFloat(element.style.fontSize) * scaleFactor;
      var newRelativeValueGap = parseFloat(element.style.gap) * scaleFactor;
      // var newRelativeValueTop = parseFloat(element.style.top) * scaleFactor;
      // var newRelativeValueLeft = parseFloat(element.style.left) * scaleFactor;
      // var newRelativeValueMarginTop =
      //   parseFloat(element.style.marginTop) * scaleFactor;
      // var newRelativeValueMarginLeft =
      //   parseFloat(element.style.marginLeft) * scaleFactor;
      // var newRelativeValueMarginBottom =
      //   parseFloat(element.style.marginBottom) * scaleFactor;
      // var newRelativeValueMarginRight =
      //   parseFloat(element.style.marginRight) * scaleFactor;

      // Update the element with the new value
      let actualfontSize = parseFloat(newRelativeValueFont);
      let requiredFontSize = parseInt(actualfontSize);
      // let letterSpacing = (actualfontSize - requiredFontSize).toFixed(2);
      element.style.fontSize = requiredFontSize + "px";
      // element.style.letterSpacing = letterSpacing + "px";

      // element.style.fontSize = Math.round(newRelativeValueFont) + "px";

      element.style.gap = Math.round(newRelativeValueGap) + "px";
      if (element.style.position !== "absolute" && element.style.position !== "relative") {
        element.style.removeProperty('top');
        element.style.removeProperty('left');
      }
      if (
        element.tagName === "TABLE" ||
        element.tagName === "TD" ||
        element.tagName === "TH"
      ) {
        let tableHeightAdjust = (parseFloat(element.style.minHeight) * 8) / 123;
        element.style.width =
          parseFloat(element.style.width) * scaleFactor + "px";
        element.style.minHeight =
          (parseFloat(element.style.minHeight) - 8) * scaleFactor + "px";
      }
      if (element.tagName === "IMG" || element.tagName === "A") {
        element.style.width =
          parseFloat(element.style.width) * scaleFactor + "px";
        // element.setAttribute("onload", () => onEachIageLoad(divs - i));
      }
    }
  };
  const upScaleImageAndFontSize = (htmlResp, scaleFactor) => {

    let htmlDOMEl = HtMLStringToDOMElement(htmlResp);
    let currentWidth = 600;
    let desiredWidth = 1024;
    var scaleFactor = desiredWidth / currentWidth;
    let wrapperDiv = htmlDOMEl.childNodes[1].childNodes[0];
    for (let k = 0; k < wrapperDiv.childNodes.length; k++) {
      let sectionDiv = wrapperDiv.childNodes[k];
      if (sectionDiv && parseFloat(sectionDiv.style.width) !== 1024) {
        replaceWithNewDimensions(sectionDiv, scaleFactor, "redLayout");
        for (let j = 0; j < sectionDiv.childNodes.length; j++) {
          if (sectionDiv.childNodes[j].getAttribute("coulumn") === "multi") {
            let column = sectionDiv.childNodes[j];
            replaceWithNewDimensions(column, scaleFactor);
            for (let i = 0; i < column.childNodes.length; i++) {
              let innerLayout = column.childNodes[i];
              replaceWithNewDimensions(innerLayout, scaleFactor);
              if (innerLayout.getAttribute("blocktype") === "LAYOUT_TABLE") {
                replaceWithNewDimensions(
                  innerLayout.childNodes[0],
                  scaleFactor
                );
                ReplaceHTMLContentsStyles(
                  innerLayout.childNodes[0],
                  scaleFactor
                );
              } else ReplaceHTMLContentsStyles(innerLayout, scaleFactor);
              if (innerLayout.getAttribute("blocktype") === "LAYOUT_LIST" || innerLayout.getAttribute("blocktype") === "LAYOUT_FIGURE_WITH_TEXT") {
                for (let m = 0; m < innerLayout.childNodes.length; m++) {
                  let listItem = innerLayout.childNodes[m];
                  replaceWithNewDimensions(listItem, scaleFactor);
                }
              }
            }
          } else if (sectionDiv.childNodes[j].getAttribute("blocktype")) {
            let innerLayoutOfRed = sectionDiv.childNodes[j];
            replaceWithNewDimensions(innerLayoutOfRed, scaleFactor);
            if (innerLayoutOfRed.getAttribute("blocktype") === "LAYOUT_TABLE") {
              replaceWithNewDimensions(
                innerLayoutOfRed.childNodes[0],
                scaleFactor
              );
              ReplaceHTMLContentsStyles(
                innerLayoutOfRed.childNodes[0],
                scaleFactor
              );
            } else ReplaceHTMLContentsStyles(innerLayoutOfRed, scaleFactor);
            if (innerLayoutOfRed.getAttribute("blocktype") === "LAYOUT_LIST" || innerLayoutOfRed.getAttribute("blocktype") === "LAYOUT_FIGURE_WITH_TEXT") {
              for (let mb = 0; mb < innerLayoutOfRed.childNodes.length; mb++) {
                let listItem = innerLayoutOfRed.childNodes[mb];
                replaceWithNewDimensions(listItem, scaleFactor);
              }
            }
          }
        }
      }
    }
    return htmlDOMEl.innerHTML;
  };
  const renderStep = () => {
    let renderContent = "";

    switch (activeStep) {
      case 0:
        renderContent = (
          <>
            {!isFileUploading ? (
              <>
                <FileUpload onFileUpload={onFileUpload} />
                <Dialog open={fileUploadMessage}>
                  <DialogTitle>{fileUploadMessage}</DialogTitle>
                </Dialog>
              </>
            ) : (
              <div className="file-upload-loader">
                <lottie-player
                  src={JSON.stringify(require("../../Images/97203.json"))}
                  background="transparent"
                  speed="1"
                  style={{ width: "226px", height: "127px" }}
                  loop
                  autoplay
                ></lottie-player>
                <span>Converting PDF to HTML. This may take a while </span>
              </div>
            )}
          </>
        );
        break;

      case 1:
        renderContent = (
          <ImageLayout
            fileDetails={imageFileDetails}
            arrayOfBoxesDrawnImage={arrayOfBoxesDrawnImage}
            setarrayOfBoxesDrawnImage={setarrayOfBoxesDrawnImage}
            imageFileDetails={imageFileDetails}
            imageDimensions={imageDimensions}
            setImageDimensions={setImageDimensions}
            scaleFactorImage={scaleFactorImage}
            setScaleFactorImage={setScaleFactorImage}
            croppingBoxes={croppingBoxes}
            setCroppingBoxes={setCroppingBoxes}
            modifiedCroppedImage={modifiedCroppedImage}
            setModifiedCroppedImage={setModifiedCroppedImage}
            ObjectOfObjectsToArrayOfObjects={ObjectOfObjectsToArrayOfObjects}
            setIsGJSLoading={setIsGJSLoading}
            setImageFileDetails={setImageFileDetails}
            setIsPublished={setIsPublished}
            setHoldCurrentFileDetails={setHoldCurrentFileDetails}
          />
        );
        break;
      case 2:
        renderContent = (
          <>
            <HTMLPreview
              arrayOfBoxesDrawn={arrayOfBoxesDrawn}
              setArrayOfBoxesDrawn={setArrayOfBoxesDrawn}
              arrayOfBoxesDrawnRef={arrayOfBoxesDrawnRef}
              setGenerateLayout={setGenerateLayout}
              genLayoutRef={genLayoutRef}
              file={file}
              fileDetails={uploadedFfileDetails}
              setUploadedFileDetails={setUploadedFileDetails}
              html={html}
              setHtml={setHtml}
              htmlRef={htmlRef}
              rhsHtmlForExport={rhsHtmlForExport}
              setRhsHtmlForExport={setRhsHtmlForExport}
              rhsHtmlForExportRef={rhsHtmlForExportRef}
              prevStep={prevStep}
              customDrag={customDrag}
              genLayoutClicked={genLayoutClicked}
              setGenLayoutClicked={setGenLayoutClicked}
              cooridinatesFromAPI={cooridinatesFromAPI}
              setCooridinatesFromAPI={setCooridinatesFromAPI}
              innerLayoutsRef={innerLayoutsRef}
              arrayOfBoxesDrawnImage={arrayOfBoxesDrawnImage}
              imageDimensions={imageDimensions}
              isGJSLoading={isGJSLoading}
              setIsGJSLoading={setIsGJSLoading}
              setIsLayoutGenerated={setIsLayoutGenerated}
              setClearAllLayoutClicked={setClearAllLayoutClicked}
              clearAllLayoutClicked={clearAllLayoutClicked}
              disableGenerateLayout={disableGenerateLayout}
              setDisableGenerateLayout={setDisableGenerateLayout}
              usrGenHtMLRef={usrGenHtMLRef}
              setActiveStep={setActiveStep}
              HtMLStringToDOMElementFromExport={
                HtMLStringToDOMElementFromExport
              }
              cssStringToCSSStyles={cssStringToCSSStyles}
              replaceIdsWithStyles={replaceIdsWithStyles}
              setIsPublished={setIsPublished}
              setDefaultHtmlStyles={setDefaultHtmlStyles}
              setarrayOfBoxesDrawnImage={setarrayOfBoxesDrawnImage}
              setImageFileDetails={setImageFileDetails}
              setHoldCurrentFileDetails={setHoldCurrentFileDetails}
              setPositionAbsolute={setPositionAbsolute}
              positionAbsolute={positionAbsolute}
            />
            {/* <div id="blocks"></div> */}
            <GrapejsEditor
              arrayOfBoxesDrawnRef={arrayOfBoxesDrawnRef}
              setArrayOfBoxesDrawn={setArrayOfBoxesDrawn}
              genLayoutRef={genLayoutRef}
              exportCount={exportCount}
              activeStep={activeStep}
              getUserGeneratedHTML={getUserGeneratedHTML}
              htmlRef={htmlRef}
              setActiveStep={setActiveStep}
              fileDetails={uploadedFfileDetails}
              rhsHtmlForExport={rhsHtmlForExport}
              setRhsHtmlForExport={setRhsHtmlForExport}
              rhsHtmlForExportRef={rhsHtmlForExportRef}
              prevStep={prevStep}
              genLayoutClicked={genLayoutClicked}
              setGenLayoutClicked={setGenLayoutClicked}
              dataRef={dataRef}
              setData={setData}
              setCooridinatesFromAPI={setCooridinatesFromAPI}
              innerLayoutsRef={innerLayoutsRef}
              setIsLayoutGenerated={setIsLayoutGenerated}
              isGJSLoading={isGJSLoading}
              setIsGJSLoading={setIsGJSLoading}
              downloadHTML={downloadHTML}
              downloadClicked={downloadClicked}
              clearAllLayoutClicked={clearAllLayoutClicked}
              setClearAllLayoutClicked={setClearAllLayoutClicked}
              usrGenHtMLRef={usrGenHtMLRef}
              upScaleImageAndFontSize={upScaleImageAndFontSize}
              setUpscaledHTMLUsrGnrtdPath={setUpscaledHTMLUsrGnrtdPath}
              setUploadedFileDetails={setUploadedFileDetails}
              HtMLStringToDOMElementFromExport={
                HtMLStringToDOMElementFromExport
              }
              cssStringToCSSStyles={cssStringToCSSStyles}
              replaceIdsWithStyles={replaceIdsWithStyles}
              isPublished={isPublished}
              userGeneratedHTML={userGeneratedHTML}
              defaultHtmlStyles={defaultHtmlStyles}
              setPositionAbsolute={setPositionAbsolute}
              positionAbsolute={positionAbsolute}
            />
          </>
        );


        break;
      case 3:
        renderContent = (
          <AddMetadata
            publishHTML={publishHTML}
            publishHTMLDSP={publishHTMLDSP}
            publishResponsiveHTML={publishResponsiveHTML}
            userGeneratedHTML={userGeneratedHTML}
            fileDetails={uploadedFfileDetails}
            downloadHTML={downloadHTML}
            downloadClicked={downloadClicked}
            downloadResponsiveHTML={downloadResponsiveHTML}
            responsiveHtml={responsiveHtml}
            setIsGJSLoading={setIsGJSLoading}
            setIsBackDisabled={setIsBackDisabled}
            isDownloadZip={isDownloadZip}
            isDownloadZipDSP={isDownloadZipDSP}

            downloadZip={setIsDownloadZip}
            downloadZipDSP={setIsDownloadZipDSP}


            upScaleImageAndFontSize={upScaleImageAndFontSize}
            upscaledHTMLUsrGnrtdPath={upscaledHTMLUsrGnrtdPath}
            isPublished={isPublished}
            exportClicked={exportClicked}
            exportDSPClicked={exportDSPClicked}
            isPublishClicked={isPublishClicked}
            setIsPublishClicked={setIsPublishClicked}
          />
        );
        break;

      default:
        renderContent = renderContent;
        break;
    }
    return renderContent;
  };
  if (isFileUploading) {
    let progressMessage = "";
    if (activeStep === STEPPER_STEP_UPLOADFILE) {
      progressMessage = UPLOAD_PDF_PROGRESS_MESSAGE;
    } else if (activeStep === STEPPER_STEP_MODIFY_IMAGE) {
      progressMessage = UPLOAD_IMAGE_PROGRESS_MESSAGE;
    }
    return (
      <div className="file-upload-loader">
        <lottie-player
          src={JSON.stringify(require("../../Images/97203.json"))}
          background="transparent"
          speed="1"
          style={{ width: "226px", height: "127px" }}
          loop
          autoplay
        ></lottie-player>
        <span> {progressMessage} </span>
      </div>
    );
  }
  return (
    <>
      <div className="Root">
        {isGJSLoading && activeStep !== 0 && (
          <CustomCircularProgress color="inherit" />
        )}
        {/* <ToastContainer /> */}
        <ButtonHeader
          exportClicked={exportClicked}
          exportResponsiveHTML={exportResponsiveHTML}
          handleBack={handleBack}
          currentStep={activeStep}
          isValidFileName={file?.isValidFileName}
          nextClick={handleNext}
          isProcessing={isFileUploading}
          isLayoutGenerated={isLayoutGenerated}
          isImageLayoutGenerated={arrayOfBoxesDrawnImage?.length}
          modifyImageCancelHandler={modifyImageIntermediateSave}
          setIsGJSLoading={setIsGJSLoading}
          downloadClicked={downloadClicked}
          downloadResponsiveHTML={downloadResponsiveHTML}
          croppingBoxes={croppingBoxes}
          disableGenerateLayout={disableGenerateLayout}
          isBackDisabled={isBackDisabled}
          fileDetails={uploadedFfileDetails}
          setIsDownloadZip={setIsDownloadZip}
          setIsDownloadZipDSP={setIsDownloadZipDSP}

          isPublished={isPublished}
          setIsPublishClicked={setIsPublishClicked}
        />
        <div className="stepper">
          <StepperComp steps={steps} activeStep={activeStep} />
        </div>
        <div className="container">{renderStep()}</div>
      </div>
    </>
  );
}

export default Root;
